import React from 'react';
import { Typography } from '@safedns/skydns-ui-react-lib';

import styles from './OldChangelogCard.module.scss';

const Dot = () => (
  <div
    style={{
      position: 'absolute',
      top: 9,
      width: 6,
      height: 6,
      background: '#c2cfe0',
      borderRadius: '50%',
    }}
  />
);

const OldChangelogCard = ({
  icon,
  agentType,
  agentVersion,
  releaseDate,
  changelog,
}) => {
  return (
    <div className={styles.card}>
      <Typography
        component="span"
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingBottom: '8px',
          textTransform: 'capitalize',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '24px',
        }}
      >
        {icon} {agentType} ({agentVersion})
      </Typography>
      <div className={styles.releaseInfo}>
        <Typography variant="subtitle2" component="span">
          Релиз:&nbsp;
        </Typography>
        <Typography variant="subtitle1" component="span">
          {releaseDate}
        </Typography>
      </div>
      <ul className={styles.changelogList}>
        {changelog.split('\r\n').map((log, logIndex) => {
          return (
            <li
              key={agentType + 'release' + logIndex}
              className={styles.changelogItem}
            >
              <Dot />
              <Typography sx={{ paddingLeft: '16px' }}>{log}</Typography>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default OldChangelogCard;
